/**
 * @description - Pdb reducer.
 * @param {Object} state - State.
 * @returns {Object} - State.
 */
const pdbReducer = (state = {}) => state;
export default pdbReducer;
